export default {
  edit_info_modal: {
    header_title: 'ตั้งค่าโปรไฟล์',
    desc_title: 'จัดการข้อมูลรูปแบบการแสดงผลข้อมูลโปรไฟล์ลูกค้าสำหรับวิเคราะห์ข้อมูลเชิงลึก',
    header_name: 'ชื่อหัวข้อ',
    header_name_required: 'กรุณากรอกชื่อกลุ่มก่อน',
  },
};
